<template>
  <div class="mx-auto w-full max-w-3xl px-2 py-6 text-lg leading-8">
    <div class="w-full text-end"><BackButton /></div>

    <slot />
  </div>
</template>

<script setup lang="ts">
import BackButton from 'src/components/common/BackButton.vue';
</script>
